import { useSelector } from 'react-redux'

import { getOrm } from 'orm'

export const useCandidateGroupData = () => {
  const { candidates } = useSelector(getOrm)

  const pks = Object.keys(candidates?.meta?.selected ?? {})

  const count = pks.length

  const items: Record<string, { id?: number | string; name?: string }> =
    candidates?.items ?? {}
  const applicants = Object.values(items).filter(
    ({ id }) => id != null && pks.includes(id.toString()),
  )

  return {
    state: {
      candidates: applicants,
      count,
      pks,
    },
  }
}
